import React from "react";
import get from "lodash/get";

import copy from "clipboard-copy";
import ToolTip from "../../../../parts/tooltip-portal";
import moment from "moment";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import { isActiveUserTheCoach } from "../../../../utils/user-helpers";

function AthleteProfileMenu({ athlete, organizationCoachId, locals }) {
  const athleteStatus = !get(athlete, "status.inactive", false);
  const activeUserId = locals.activeUser._id;
  const organizationCoach = locals.query.organizationCoach || undefined;
  const section = locals.query.section;
  const { organizationRoleName } = locals;
  const theme = locals.activeUser.webAppTheme || "dark";
  const isOrganizationUserAndAllowToSendMessage =
    organizationRoleName === "Admin" ||
    organizationRoleName === "Owner" ||
    organizationRoleName === "Nutritionist";

  async function handleClick(e) {
    e.preventDefault();
    await copy(athlete.email);
    submit("/actions/refresh", {
      method: "GET",
      body: {
        copied: true,
      },
    });
  }

  function sendMessage(e) {
    e.preventDefault();
    submit(`/actions/user/check-chat-users/${athlete._id}/${false}`, {
      method: "POST",
      body: {},
    });
  }

  return (
    <article className={section !== "dashboard" ? "force-mobile-hidden" : ""}>
      <header>
        <span data-status={athleteStatus ? "active" : "inactive"}>
          {athleteStatus ? " Active" : " Inactive"}
        </span>
      </header>
      <section>
        <img src={getAvatarUrl(athlete, null, theme)} />
        <h5>{athlete.name}</h5>
        <div>
          <p className="p4">{athlete.email} </p>

          <ToolTip
            id="copy-email"
            body="Copy email to clipboard"
            childrenContainerClass="tooltip-coach"
          >
            <SvgIcon
              alt="copy"
              src="/img/new-icons/copy-grey.svg"
              onClickFn={handleClick}
            />
          </ToolTip>
        </div>
      </section>
      <footer>
        {athleteStatus && (
          <a
            href={
              organizationCoach
                ? `/athlete-portal/profile/exercise-library/?athlete=${athlete._id}&organizationCoach=${organizationCoach}`
                : `/athlete-portal/profile/exercise-library/?athlete=${athlete._id}`
            }
            role="button"
            data-button-type="secondary"
          >
            Exercise Library
          </a>
        )}
        {(!organizationCoachId ||
          isActiveUserTheCoach(activeUserId, organizationCoachId) ||
          isOrganizationUserAndAllowToSendMessage) && (
          <a role="button" data-button-type="secondary" onClick={sendMessage}>
            Send Message
          </a>
        )}
      </footer>
      {/* <div className="only-show-mobile">
        {!athlete.isGymMember && organizationRoleName !== "Nutritionist" && (
          <div className="Profile start-remove-buttons">
            <a
              className="Profile button remove-button"
              href={`/actions/refresh?modal[type]=${
                athleteStatus ? "stop-training" : "remove-athlete"
              }`}
            >
              {athleteStatus ? "Stop Training" : "Remove"}
            </a>
          </div>
        )}
      </div> */}
    </article>
  );
}

export default AthleteProfileMenu;
